export function getCookie(cookieName: string): string {
  const cookies = document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .filter((cookie) => cookie.startsWith(`${cookieName}=`));

  return cookies.length === 0 ? '' : decodeURIComponent(cookies[0].split('=')[1]);
}
